import { default as SiteLocaleEn } from '../../../../locales/en.default.json';
import { default as SiteLocaleFr } from '../../../../locales/fr.json';

/**
 * This function can be used for locale translation in javascript files
 *
 * @param {string} string the translation string to be used. eg: 'product.sale'
 * @param {object} replacements an object with each key being the string to be replaced and the value being what to replace it with.
 */
const getTranslation = (string, replacements) => {
  const languages = {
    en: SiteLocaleEn,
    fr: SiteLocaleFr,
  };

  const currentTranslation = languages[Shopify.locale]
    ? languages[Shopify.locale]
    : languages.en;

  let translation = string
    .split('.')
    .reduce((acc, cur) => acc[cur], currentTranslation);

  if (replacements) {
    Object.entries(replacements).forEach(([key, val]) => {
      translation = translation.replaceAll(`{{ ${key} }}`, val);
    });
  }

  return translation;
};

/**
 * This function can strips the is from a string
 * @param {string} string the string to be stripped
 *
 */

const getIdfromGid = string => {
  const value = string.split('/').pop();
  return parseInt(value);
};

const mapEdgesToNodes = data => {
  if (!data?.edges) {
    return [];
  }

  return data.edges.map(edge => edge.node);
};

/**
 * This triggers an update on the react cart and upsells
 * @param {boolean} openMiniCart
 * @param {string} upsellItem
 */

const updateReactCart = openMiniCart => {
  const preactApp = document.querySelector('#pxu-preact-app');
  preactApp.dispatchEvent(
    new CustomEvent('updateReactCart', { detail: { openMiniCart } }),
  );
};

export { getTranslation, updateReactCart, mapEdgesToNodes, getIdfromGid };
